// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "contacts-2mEsT";
var _4 = "description__header-38VY5";
var _5 = "description__text-3YgSG";
var _6 = "description__content-1PBan";
var _7 = "checkbox__label-1Hac6";
var _8 = "header-1fBSw";
var _9 = "footer__inner-3rh-7";
var _a = "footer__text-2HztY";
var _b = "footer_login-2w-IG";
export { _1 as "__esModule", _2 as "mobile", _3 as "contacts", _4 as "description__header", _5 as "description__text", _6 as "description__content", _7 as "checkbox__label", _8 as "header", _9 as "footer__inner", _a as "footer__text", _b as "footer_login" }
export default { "__esModule": _1, "mobile": _2, "contacts": _3, "description__header": _4, "description__text": _5, "description__content": _6, "checkbox__label": _7, "header": _8, "footer__inner": _9, "footer__text": _a, "footer_login": _b }
